import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=77c38dac&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=77c38dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c38dac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c38dac')) {
      api.createRecord('77c38dac', component.options)
    } else {
      api.reload('77c38dac', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=77c38dac&scoped=true&", function () {
      api.rerender('77c38dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28Se2gCaGzT4S/JS/comp/SearchFilterTokens.vue"
export default component.exports